{
  "nav": {
    "heading": "Back-office",
    "users": "Utilisateurs",
    "auditLog": "Journal d'audit",
    "backToApp": "Retour au site",
    "outbox": "File d'événements",
    "reports": "Modération",
    "stats": "Statistiques",
    "flags": "Feature flags"
  },
  "users": {
    "heading": "Utilisateurs",
    "search": "Rechercher",
    "searchPlaceholder": "Nom ou adresse email",
    "filterStatus": "Statut",
    "filterRole": "Rôle",
    "any": "Tous",
    "empty": "Aucun compte ne correspond à ces critères.",
    "loading": "Chargement des comptes…",
    "columns": {
      "user": "Utilisateur",
      "status": "Statut",
      "roles": "Rôles",
      "createdAt": "Inscription",
      "lastLogin": "Dernière connexion"
    },
    "never": "Jamais",
    "deletionPending": "Suppression programmée"
  },
  "status": {
    "pending": "En attente",
    "active": "Actif",
    "suspended": "Suspendu",
    "deactivated": "Désactivé"
  },
  "detail": {
    "heading": "Fiche utilisateur",
    "back": "Retour à la liste",
    "identity": "Identité",
    "roles": "Rôles",
    "activity": "Historique administratif",
    "noActivity": "Aucune action administrative sur ce compte.",
    "loading": "Chargement de la fiche…",
    "emailVerified": "Email vérifié",
    "emailUnverified": "Email non vérifié",
    "grantRole": "Attribuer",
    "revokeRole": "Retirer",
    "rolePlaceholder": "Choisir un rôle",
    "profile": "Profil",
    "profileEmpty": "Ce compte n'a rien renseigné.",
    "headline": "Titre",
    "bio": "Biographie",
    "subjects": "Matières",
    "languages": "Langues",
    "website": "Site personnel",
    "profileVerified": "Profil vérifié",
    "profileUnverified": "Profil non vérifié",
    "preferences": "Préférences et consentements",
    "preferencesHelp": "Constatés, non modifiables : un consentement recueilli par un tiers n'en est pas un.",
    "shareProgress": "Partage de progression avec les enseignants",
    "marketingEmails": "Emails d'information",
    "theme": "Thème",
    "granted": "Accordé",
    "refused": "Refusé",
    "deletionScheduled": "Ce compte sera anonymisé le {{date}}, à la demande de son titulaire.",
    "deletionRequestedAt": "Demande reçue le {{date}}. Le titulaire peut encore se raviser jusqu'à l'échéance."
  },
  "actions": {
    "suspend": "Suspendre",
    "reactivate": "Réactiver",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "reason": "Motif",
    "reasonHelp": "Obligatoire, 10 caractères minimum. Il sera conservé au journal d'audit.",
    "suspendTitle": "Suspendre ce compte",
    "suspendWarning": "L'utilisateur ne pourra plus se connecter et ses sessions ouvertes seront fermées.",
    "reactivateTitle": "Réactiver ce compte",
    "reactivateWarning": "L'utilisateur pourra de nouveau se connecter. Ses anciennes sessions restent fermées.",
    "grantRoleTitle": "Attribuer un rôle",
    "revokeRoleTitle": "Retirer un rôle",
    "roleWarning": "Ce changement prend effet à la prochaine connexion de l'utilisateur, et sera consigné au journal d'audit."
  },
  "audit": {
    "heading": "Journal d'audit",
    "description": "Toute action administrative y est consignée. Le journal ne peut être ni modifié ni effacé.",
    "empty": "Aucune entrée.",
    "loading": "Chargement du journal…",
    "filterAction": "Action",
    "columns": {
      "date": "Date",
      "action": "Action",
      "actor": "Auteur",
      "target": "Cible",
      "reason": "Motif"
    },
    "system": "Système",
    "noReason": "—"
  },
  "actionNames": {
    "user.suspended": "Compte suspendu",
    "user.reactivated": "Compte réactivé",
    "user.role_granted": "Rôle attribué",
    "user.role_revoked": "Rôle retiré"
  },
  "errors": {
    "cannotTargetSelf": "Vous ne pouvez pas effectuer cette action sur votre propre compte.",
    "reasonTooShort": "Le motif doit faire au moins 10 caractères."
  },
  "outbox": {
    "heading": "File d'événements",
    "description": "Ce qui n'a pas encore été publié, et pourquoi. Le plus ancien d'abord : c'est ce qui bloque la file.",
    "empty": "La file est vide — tout est publié.",
    "deadLetters": "{{deadValue}} événement(s) ont épuisé leurs tentatives et ne repartiront pas seuls.",
    "deadLetter": "Abandonné",
    "attempts": "{{attemptsValue}} tentative(s)",
    "nextAttempt": "Prochaine tentative : {{when}}",
    "replay": "Rejouer",
    "confirmReplay": "Confirmer le rejeu",
    "cancel": "Annuler",
    "reasonLabel": "Motif du rejeu",
    "reasonPlaceholder": "Pourquoi rejouer cet événement ?",
    "views": {
      "unpublished": "Tout ce qui reste",
      "pending": "En attente",
      "failed": "En échec"
    }
  },
  "reports": {
    "heading": "Modération",
    "description": "Les contenus signalés, du plus ancien au plus récent. Ouvrir un contenu est consigné au journal d'audit.",
    "openOnly": "Dossiers ouverts seulement",
    "empty": "Aucun signalement à traiter.",
    "noDetails": "Le signaleur n'a pas ajouté de précision.",
    "status": "Statut : {{statusValue}}",
    "alsoReported": "signalé {{countValue}} fois",
    "disclose": "Consulter le contenu",
    "discloseAudited": "Cette consultation sera écrite au journal d'audit, avec votre nom et l'heure.",
    "windowGone": "La fenêtre de 72 heures est écoulée : le contenu ne peut plus être ouvert.",
    "itemDeleted": "Message supprimé par son auteur — conservé pour la modération.",
    "itemHidden": "Message déjà retiré par la modération.",
    "decision": "Décision",
    "note": "Motif de la décision",
    "notePlaceholder": "Ce que vous avez constaté, et pourquoi vous tranchez ainsi.",
    "submit": "Trancher",
    "alreadyHandled": "Ce signalement a déjà été traité. Motif retenu : {{noteValue}}",
    "actions": {
      "reject": "Rejeter",
      "warn": "Avertir",
      "hide": "Masquer",
      "suspend": "Suspendre"
    },
    "reasons": {
      "spam": "Spam",
      "harassment": "Harcèlement",
      "inappropriate": "Contenu inapproprié",
      "other": "Autre"
    },
    "statuses": {
      "open": "ouvert",
      "reviewing": "en cours d'examen",
      "resolved": "traité",
      "rejected": "rejeté"
    },
    "entities": {
      "messaging.message": "Message privé"
    }
  },
  "stats": {
    "title": "Statistiques",
    "subtitle": "L'état de la plateforme, calculé à la lecture. Aucun taux n'est calculé côté serveur : les nombres sont bruts.",
    "accounts": "Comptes",
    "accountsDetail": "{{active}} actifs · {{suspended}} suspendus",
    "courses": "Cours publiés",
    "coursesDetail": "{{drafts}} brouillons",
    "enrollments": "Inscriptions",
    "enrollmentsDetail": "dont {{completed}} terminées",
    "certificates": "Certificats émis",
    "certificatesDetail": "dont {{revoked}} révoqués",
    "mrr": "Revenu mensuel",
    "mrrDetail": "{{subscribers}} abonnements en cours",
    "storage": "Stockage",
    "storageDetail": "{{files}} fichiers",
    "gigabytes": "{{value}} Go",
    "unpriced": "{{count}} abonnement(s) en cours n'ont aucun tarif attaché : le revenu affiché les ignore.",
    "growth": "Croissance",
    "window": "Fenêtre d'observation",
    "days": "{{count}} jours",
    "chartLabel": "{{series}}, jour par jour sur {{days}} jours",
    "point": "{{day}} : {{count}}",
    "series": {
      "signups": "Inscriptions de comptes",
      "coursesPublished": "Cours mis en ligne",
      "enrollments": "Inscriptions à un cours",
      "completions": "Cours terminés"
    }
  },
  "flags": {
    "title": "Feature flags",
    "subtitle": "Les interrupteurs des fonctionnalités. Couper agit immédiatement, pour toute la plateforme, et le geste est consigné au journal d'audit.",
    "noDescription": "Aucune description : ce flag ne dit pas ce qu'il garde.",
    "open": "Ouvert",
    "closed": "Coupé",
    "open_action": "Rouvrir",
    "close": "Couper",
    "cancel": "Annuler",
    "confirmClose": "Couper pour toute la plateforme ?",
    "updatedAt": "modifié le {{at}}"
  }
}
